import React from 'react';
import { Container } from 'reactstrap';
import CrudList from './list';

const Requerimento = () => (
  <div className="containerInside__wrap">
    <Container>
      <CrudList />
    </Container>
  </div>
);

export default Requerimento;